import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const DIRECTIONS = {
  LTR: 'ltr',
  RTL: 'rtl'
};
const DirectionContext = /*#__PURE__*/createContext();
const DirectionProvider = _ref => {
  let {
    direction: initialDirection = DIRECTIONS.LTR,
    ...props
  } = _ref;
  const [direction, setDirection] = useState(initialDirection);
  const setDirectionContext = newDirection => setDirection(newDirection);
  return /*#__PURE__*/_jsx(DirectionContext.Provider, {
    value: {
      direction,
      setDirectionContext
    },
    ...props
  });
};
DirectionProvider.propTypes = {
  direction: PropTypes.oneOf(Object.values(DIRECTIONS))
};
const useDirection = () => {
  const context = useContext(DirectionContext);
  if (!context) {
    throw new Error('useDirection must be used within a DirectionProvider');
  }
  return {
    ...context,
    isRTL: context.direction === DIRECTIONS.RTL
  };
};
export { DIRECTIONS, DirectionProvider, useDirection };
//# sourceMappingURL=DirectionContext.js.map